import { CarouselItem } from "@atoms/carousel-item";
import { Section } from "@atoms/section";
import { Typography } from "@atoms/typography";
import {
  BlogListArticle,
  BlogListArticleProps,
} from "@organisms/blog-list-article";
import { LayoutTemplate } from "@templates/layout";
import { useTranslation } from "next-i18next";
import { FC } from "react";
import styled from "styled-components";

export type BlogListTemplateProps = {
  articles: BlogListArticleProps[];
};

export const BlogListTemplate: FC<BlogListTemplateProps> = ({ articles }) => {
  const { t } = useTranslation("blog");

  return (
    <LayoutTemplate page="blog">
      <CarouselItem
        imageStandard="/images/header_faq.jpg"
        imageWebp="/images/header_faq.webp"
      />
      <Section>
        <Typography variant="title1">{t("title")}</Typography>
        <Grid>
          {articles.map((c, i) => (
            <BlogListArticle
              key={`article_${i}`}
              cover={c.cover}
              title={c.title}
              slug={c.slug}
            />
          ))}
        </Grid>
      </Section>
    </LayoutTemplate>
  );
};

const Grid = styled("div")`
display: grid;
    gap: 1rem;
    align-items: center;
    justify-content: center;
    grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
    overflow: hidden;
}
`;
